import {
  type AuthenticationResult,
  type EventPayload,
} from '@azure/msal-browser';

export function isAuthenticationResult(
  payload: EventPayload,
): payload is AuthenticationResult {
  return !!(payload as AuthenticationResult).account;
}
